function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './Phone.css';
import React, { useEffect, useState } from 'react';
import { PhoneInput } from './PhoneInput/PhoneInput';
const BASE_URL = process.env.REACT_APP_MEDIA_HOST ? process.env.REACT_APP_MEDIA_HOST : '';
const Phone = props => {
  const {
    required = false,
    label = 'phone',
    placeholder = '',
    name = 'phone',
    rtl = false,
    patternInvalidMessage = 'validateError',
    validate = false,
    value: contextValue,
    code: contextCode = '',
    countryValues = [],
    updateContext,
    code = '',
    isDisablePlus = false
  } = props;
  const [value, setValue] = useState({
    number: '',
    code: '',
    valid: true
  });
  const [inValid, setInValid] = useState(false);
  const onChangeEvent = val => {
    if (val.valid) required && setInValid(!val.valid);
    setValue(v => _objectSpread(_objectSpread({}, v), val));
  };
  const validating = val => {
    required && setInValid(!val.valid);
  };
  useEffect(() => {
    if (validate) required && setInValid(!value.valid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validate]);
  useEffect(() => {
    if (contextValue && contextValue.length) {
      setValue(val => _objectSpread(_objectSpread({}, val), {
        number: contextValue,
        code: contextCode.length ? contextCode : val.code
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contextValue, code, contextCode]);
  useEffect(() => {
    if (value.number.length || value.code.length) {
      updateContext({
        [name]: _objectSpread(_objectSpread({}, props), {}, {
          valid: required && value.valid,
          value: `${value.number}`,
          code: `${isDisablePlus ? value.code.replace('+', '') : value.code}`
        })
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  return /*#__PURE__*/React.createElement("fieldset", {
    className: ` ${commonStyles}  ${rtl ? rtlStyles : ltrStyles} `
  }, /*#__PURE__*/React.createElement("label", {
    className: `body-small wiz__label `,
    htmlFor: name
  }, label), /*#__PURE__*/React.createElement(PhoneInput, {
    countryItems: countryValues.map(el => {
      return {
        code: el.countryCode.jss.value,
        countryName: el.countryName.jss.value,
        text: el.phoneCode.jss.value,
        value: el.phoneCode.jss.value,
        flag: el.flag.jss.value.alt,
        flagSrc: `${BASE_URL}/${el.flag.jss.value.src}`
      };
    }),
    name: name,
    code: contextCode,
    placeholder: placeholder,
    onChange: val => onChangeEvent(val),
    onBlur: val => validating(val),
    value: value,
    phoneInputClass: `form-field__phone-input ${inValid ? ' invalid-field' : ''}`,
    required: required,
    customLayout: true,
    minLength: 9,
    maxLength: 14
  }), inValid && /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("p", {
    className: "text-input__error"
  }, patternInvalidMessage)));
};
const commonStyles = "c1gjv6a2";
const rtlStyles = "r9nldya";
const ltrStyles = "l11vpw5w";
export default Phone;